<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">我的钱包</div>
      <div class="nav-right" @click="goto_purse()">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="top ub ub-pc ub-ac2">
      <div class="info-blcok">
        <img :src="user_info.photo" class="photo" />

        <div class="info-nick">
          <span>{{ user_info.nick }}</span>
          <span>可兑换积分:{{ score_left }}</span>
        </div>
      </div>
      <div class="tx-btn" @click="goto_tx_mny()">提现</div>
    </div>

    <div class="income-block">
      <div class="income">
        <div class="ub">
          <img src="../../assets/img/new/余额.png" class="icon" />
          <span>我的收益</span>
        </div>
        <div class="menu-line"></div>

        <ul class="ub ub-ac1">
          <li class="income-item ub ub-ver ub-pc ub-ac1">
            <span class="mny">￥{{ mny_today }}</span>
            <span class="dtm">今日</span>
          </li>

          <li class="y"></li>

          <li class="income-item ub ub-ver ub-pc ub-ac1">
            <span class="mny">￥{{ mny_yest }}</span>
            <span class="dtm">昨日</span>
          </li>

          <li class="y"></li>

          <li class="income-item ub ub-ver ub-pc ub-ac1">
            <span class="mny">￥{{ mny_total }}</span>
            <span class="dtm">累计</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="function-block ub">
          <ul class="function ub ub-ac2">
            <li class="ub ub-ver ub-pc" @click="goto_scoredtl()">
              <div class="item ub ub-pc ub-ac">
                <img src="../../assets/img/new2024/earning-details.png" />
              </div>
              <span>挣钱明细</span>
            </li>

            <li class="ub ub-ver ub-pc" @click="goto_makeMoney_dtl()">
              <div class="item ub ub-pc ub-ac">
                <img src="../../assets/img/new2024/earning-strategy.png" />
              </div>
              <span>挣钱攻略</span>
            </li >

            <li class="ub ub-ver ub-pc" @click="goto_scorenote()">
              <div class="item ub ub-pc ub-ac">
                <img src="../../assets/img/new2024/score-explain.png" />
              </div>
              <span>积分说明</span>
            </li>

            <li class="ub ub-ver ub-pc" @click="goto_txrecord()">
              <div class="item ub ub-pc ub-ac">
                <img src="../../assets/img/new2024/withdrawal -records.png" />
              </div>
              <span>提现记录</span>
            </li>

          </ul>
    </div>

    <!-- 积分奖励 -->
    <div class="activity-block" v-if="sex == '女生'">
      <div class="ub ub-pc ub-ac" @click="goto_gift_activity()">
        <img src="../../assets/img/new2024/reward-points.png" class="activity-img" />
      </div>
    </div>

    <div class="activity-block" v-if="user_master == ''"  @click="goto_master()">
      <div class="activity">
        <div class="tit ub ub-pc">
          <span class="title">我的师父</span>
          <img class="bg-tag" src="../../assets/img/new2024/bg-all.png" alt="">
        </div>
        <div class="master ub ub-pc">
          你当前还未拜师，<label>去选个师父吧~</label>
        </div>
      </div>
    </div>

    <div class="activity-block" v-if="user_master != ''">
      <div class="activity">
        <div class="tit ub ub-pc ub-ac2">
          <div class="ub ub-pc">
            <span class="title">我的师父</span>
            <img class="bg-tag" src="../../assets/img/new2024/bg-all.png" alt="">
          </div>
          <span class="relieve" @click="relieve()">解除</span>
        </div>

        <div class="master2 ub ub-pc" @click="goto_chat()">
          <img :src="user_master.photo" class="master-photo" />
          <div class="ub ub-f1 ub-ac2">
            <div class="ub ub-ver">
              <span class="nike">{{ user_master.nick }}</span>
              <div class="score ub ub-pc">
                <img v-if="user_master.sex == '女生'" src="../../assets/img/女.png" class="sex-img"/>
                <img v-if="user_master.sex == '男生'" src="../../assets/img/男.png" class="sex-img"/>
                <span :class="user_master.sex != '女生' ? 'sex2' : 'sex'">{{user_master.sex}}</span>
              </div>
            </div>

            <div class="score2 ub ub-ver">
              <span class="sp" >总积分:<label class="la">{{user_master.s_total}}</label></span>
              <span class="sp score">当日积分:<label class="la">{{user_master.s_today}}</label></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="activity-block">
      <div class="activity">
        <div class="tit ub ub-pc ub-ac2">
          <div class="ub ub-pc">
            <span class="title">我的徒弟</span>
            <img class="bg-tag" src="../../assets/img/new2024/bg-all.png" alt="">
          </div>
          <span class="relieve" v-if="student.count > 0"  @click="goto_relieve()">解除</span>
        </div>
        <div class="pupil ub ub-ac ub-ver" @click="goto_pupil()">
          <div class="ub ub-pc">
            <img v-for="(item, index) in student.list_photo" :key="index" :src="item" class="stud-photo"/>
          </div>

          <ul class="ub ub-pc ub-ac2">
            <li>
              <span class="sp">徒弟:<label class="la">{{ student.count }}</label>人</span>
            </li>
            <li>
              <span class="sp">今日积分:<label class="la">{{ student.s_today }}</label></span>
            </li>
            <li>
              <span class="sp">昨日积分:<label class="la">{{ student.s_yest }}</label></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="height: 2rem"></div>
    <dlg ref="myForm" @formBehavior="formact_relieve"></dlg>
    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../../components/Form.vue";
import Alert from "../../components/Alert.vue";
export default {
  components: {
    dlg: Form,
    alert: Alert,
  },
  data() {
    return {
      score_left: 5120,
      coin_left: 0,
      sex: "女生",
      user_info: {
        nick: "",
        photo: "",
        score_total: 0,
      },
      mny_today: 0,
      mny_yest: 0,
      mny_total: 0,

      user_master: "",
      student: {
        list_photo: [],
        count: 0,
        s_today: 0,
        s_yest: 0,
      },
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo","act_sub_coin"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_tx_mny() {
      var uid = this.$store.state.uid;
      if (uid == "wx_XPXNVKMOEEZS8PMH") {
        this.$toast.center("该功能正在维护中~");
        return false;
      }
      this.$router.push({ name: "tx_mny" });
    },
    goto_scoredtl() {
      this.$router.push({ name: "scoredtl" });
    },
    goto_makeMoney_dtl() {
      this.$router.push({ name: "mkmny" });
    },
    goto_txrecord() {
      this.$router.push({ name: "txrecord" });
    },
    goto_scorenote() {
      this.$router.push({ name: "scorenote" });
    },
    goto_purse() {
      this.$router.push({ name: "my_purse" });
    },
    goto_gift_activity() {
      this.$router.push({ name: "task_score" });
    },
    goto_master() {
      this.$router.push({ name: "master" });
    },
    goto_pupil() {
      this.$router.push({ name: "pupil" });
    },
    goto_relieve() {
      this.$router.push({ name: "relieve" });
    },
    goto_chat() {
      var uid_to = this.user_master.uid;
      this.$router.push({ name: "chart", params: { uid: uid_to } });
    },
    init_page() {
      //加载业务数据
      var self = this;
      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user_info = u;
          self.score_left = u.score_left;
          if (self.score_left < 0) {
            self.score_left = 0;
          }
          self.coin_left = u.coin_left;
          self.sex = u.sex;
        },
      });

      self.get({
        url: "/App/GetMny_Chat/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.mny_today = data.mny_today;
          self.mny_yest = data.mny_yest;
          self.mny_total = data.mny_total;
        },
      });

      self.get({
        url: "/App/GetMasterUid/?uid=" + uid,
        success: function (data) {
          self.user_master = data;
          //console.log(JSON.stringify(self.user_master));
          if (data) {
            data.photo = self.$store.state.url + "/photo/" + data.photo;
          }
        },
      });

      self.get({
        url: "/App/GetApprenticeSum/?uid=" + uid,
        success: function (data) {
          self.student = data;
          var ary = data.list_photo;
          ary = JSON.parse(ary);
          for (var i = 0; i < ary.length; i++) {
            ary[i] = self.$store.state.url + "/photo/" + ary[i];
          }
          self.student.list_photo = ary;
        },
      });
    },

    //解除师徒关系
    relieve() {
      var h =
        "<div>\
            <div style='border:1px solid #dcdcdc;border-radius: 0.3em; padding: 0.5em;font-size:.9em;'> 一日为师，终身为父，请三思哈；如果确实要解除师徒关系，你需要支付300金币赠送给师父，以此来断绝师徒关系，点击下方【解除】按钮，即可马上解除师徒关系</div>\
            </div>";

      this.$refs.myForm.show(h, {
        type: "confirm",
        confirmText: "解除",
        titleText: "解除师徒关系",
        data: "",
      });
    },

    formact_relieve(type, data) {
      if (type != "clickConfirm") {
        return false;
      }

      if (this.coin_left < 300) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }


      //扣除金币
      var uid = this.$store.state.uid;
      var uid_to = this.user_master.uid;
      var data = {
        "uid":uid,
        "uid_to":uid_to,
        "coin":300
      };
      this.sub_coin_relieve(data);
      
    },

    dorelieve() {
      var uid = this.$store.state.uid;
      var uid_to = this.user_master.uid;
      var self = this;
      self.get({
        url: "/App/T_Unbundling/?uid=" + uid + "&uid_to=" + uid_to,
        success: function (data_rst) {
          //console.log(data_rst);
          if (data_rst == "1") {
            self.$toast.center("解除成功");
            self.init_page();
          } else {
            self.$toast.center("解除失败,请退出重试");
          }
        },
      });
    },

    //扣除金币
    sub_coin_relieve(data) {
     
      var send_data = {
        "uid_from": data.uid,
        "uid_to": data.uid_to,
        "amount": data.coin,
        "type_dtl": "解除师徒关系",
        "comment": "徒弟发起",
      };
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
         //console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.dorelieve();
          }
        },
      });
    },

    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-top {
  background-color: #8A61FF;
}

.top {
  padding: 1.1rem 1.5rem 3rem 1.5rem;
  background-color: #8A61FF;
  background-image: linear-gradient(to bottom, #8A61FF, #FE9CC0);
  .info-blcok {
    display: flex;
    margin-bottom: 1px;
    .photo {
      width: 5rem;
      height: 5rem;
      margin: 0.5rem 0.5rem 0.5rem 0;
      pointer-events: none;
      border-radius: 50%;
    }
    .info-nick {
      padding: 0.5rem 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 0.3rem;
      span {
        color: #fff;
        display: inline-block;
        font-size: 0.95rem;
      }
    }
  }
  .tx-btn {
    font-weight: 600;
    background-color: #fff;
    border-radius: 1rem;
    text-align: center;
    line-height: 2rem;
    width: 4.5rem;
    height: 2rem;
    color: rgb(186, 97, 255);
  }
}

.income-block {
  padding: 0 0.9rem;
  margin-top: -2rem;
  .income {
    background-color: #fff;
    padding: 0.5rem 0.8rem;
    border-radius: 0.5rem;
    .icon {
      padding: 0 0.3rem 0.5rem 0;
      width: 1.4rem;
      height: 1.4rem;
    }
    .y {
      border: 0.8px solid #f1f1f1;
      margin-top: 0.5rem;
      height: 4rem;
    }
    .income-item {
      width: 5rem;
      height: 4.5rem;
      .mny {
        font-weight: 600;
        font-size: 1.2rem;
        color: rgb(186, 97, 255);
      }
      .dtm {
        color: #999;
        font-size: 0.85rem;
      }
    }
  }
}

.function-block {
      margin: 1rem 0.8rem 0 0.8rem;
      background-color: #FDFDFD;
      border-radius: 0.5rem;
        .function {
        padding: 0.8rem 0.8rem;
        width: 100%;
        
        .item {
          width: 2.75rem;
          height: 2.75rem;
          border-radius: 50%;
        }
        img {
          width: 1.3rem;
          height: 1.5rem;
        }
        span {
          font-size: 0.75rem;
          margin-top: 0.8rem;
        }
      }
      .function li:nth-child(1) .item {
        background-color: #E0618C;
      }

      .function li:nth-child(2) .item {
        background-color: #8B62FF;
      }

      .function li:nth-child(3) .item {
        background-color: #94E7E0;
      }

      .function li:nth-child(4) .item {
        background-color: #EDCB63;
      }
}

.activity-block {
  padding: 1rem 0.9rem 0 0.9rem;
  .activity {
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 0.5rem;
    font-size: 0.85rem;
    height: 7.22rem;
    .tit {
      margin-bottom: 0.5em;
      height: 1.2rem;
      .title {
        color: #000;
      }
      .bg-tag {
        width: 0.5rem;
        height: 0.5rem;
        margin-left: 0.1rem;
        margin-bottom: 0.7rem;
      }
      .relieve {
        color: #ddd;
      }
    }
    .pupil {
        text-align: center;
        border-top: 1px dashed #f1f1f1;
        color: #f5c209;
        .stud-photo {
          width: 2rem;
          border-radius: 50%;
          margin-bottom: 0.5rem;
        }
        height: 6.02rem;
        .sp {
          color: #888;
          .la {
            color: rgb(186, 97, 255);
            font-size: 1.2rem;
            font-weight: bold;
          }
        }
      }
    .master {
      border-top: 1px dashed #f1f1f1;
      color: #888;
      height: 6.02rem;
      label {
        color: rgb(186, 97, 255);
      }
    }
    .master2 {
      border-top: 1px dashed #f1f1f1;
      color: #f34d37;
      height: 6.02rem;
      .master-photo {
        width: 4rem;
        border-radius: 50%;
        margin-right: 0.5rem;
      }
      .nike {
        color: #333;
      }
      .score {
        margin-top: 0.8rem;
        .sex-img {
          width: 1.25rem;
        }
        .sex {
          color: #ff3ec9;
        }
        .sex2 {
          color: #37b8d5;
        }
      }
      .score2 {
        width: 12rem;
        .la {
          color: #e92162;
          font-size: 1.2rem;
          font-weight: bold;
        }
      }
    }
  }
  .activity-img {
      width: 100%;
      border-radius: 0.5rem;
    }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .nav-top {
    background-color: #3c296e;
  }
  .top {
    background-image: linear-gradient(to bottom, #3c296e, #5f3b48);
  }
  .income-block {
    .income {
      background-color: #38363f;
      span {
        color: #FDFDFD;
      }
      .dtm {
        color: #999;
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
    .y {
      border: 0.8px solid #404040;
    }
  }
  .function-block {
    background-color: #38363f;
    .function {
      span {
        color: #FDFDFD;
      }
    }
  }
  .activity-block {
    .activity {
      background-color: #38363f;
      .tit {
        .title {
          color: #FDFDFD;
        }
        .relieve {
          color: #404040;
        }
      }
      .master {
        border-top: 1px dashed #404040;
      }
      .master2 {
        border-top: 1px dashed #404040;
        .nike {
          color: #FDFDFD;
        }
      }
      .pupil {
        border-top: 1px dashed #404040;
      }
    }
  }
}
</style>